import api from '../socket';

export const getUserInfo = () => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'GetUserContent',
        options: {},
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/App/requests/get_content_request.js